import { render, staticRenderFns } from "./order_deliver_edit.vue?vue&type=template&id=94276864&scoped=true"
import script from "./order_deliver_edit.vue?vue&type=script&lang=js"
export * from "./order_deliver_edit.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "94276864",
  null
  
)

export default component.exports